angular.module('shared').factory('LateCancellationService', ["$modal", function($modal) {
  return {
    cancel: function(booking, eventId) {
      return $modal.open({
        template: require('templates/gyms/calendar/late_cancellation_modal.html.slim'),
        resolve: {
          booking: function() {
            return booking;
          }
        },
        controller: ["$scope", "$rootScope", "$modalInstance", "$http", "booking", function($scope, $rootScope, $modalInstance, $http, booking) {
          var gym, ref;
          gym = $rootScope.gym;
          $scope.currency = gym.currency_symbol;
          $scope.booking = booking;
          $scope.hasLateFee = !!((ref = booking.absent_fee_details) != null ? ref.fee_amount : void 0);
          $scope.params = {
            late_cancellation_fee: $scope.hasLateFee ? 0 : parseFloat(booking.late_cancellation_fee)
          };
          if (booking.membership_id) {
            $scope.params.use_up_class_allocation = booking.late_cancellation_uses_up_class_allocation;
          }
          $scope.useUpClassAllocationOptions = [[true, 'Yes'], [false, 'No']];
          $scope.cancelBooking = function() {
            var fee, url;
            url = `/gyms/${gym.id}/calendar/events/${booking.event_id}/bookings/${booking.id}/late_cancel`;
            fee = $scope.params.late_cancellation_fee;
            if (fee < 0 || (fee && fee < 1)) {
              $scope.error = 'Should be equal to 0 or greater than 1';
              return;
            }
            $scope.isLoading = true;
            return $http.delete(url, {
              params: $scope.params
            }).then(function() {
              $scope.isLoading = false;
              return $modalInstance.close();
            }, function() {
              return $scope.isLoading = false;
            });
          };
          return $scope.close = function() {
            return $modalInstance.dismiss('cancel');
          };
        }]
      });
    }
  };
}]);
